import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import * as api from "./api";

// 引入全局样式变量
import "./styles/variables.css";

// Vant 按需引入（在 babel 中配置了 babel-plugin-import，这里只引入用到的组件）
import {
  Tabbar,
  TabbarItem,
  NavBar,
  Button,
  Form,
  Field,
  Cell,
  CellGroup,
  Icon,
  Image as VanImage,
  Grid,
  GridItem,
  Empty,
  Toast,
  Dialog,
  Loading,
  List,
  PullRefresh,
  Popup,
  Picker,
  Tab,
  Tabs,
  Tag,
  Collapse,
  CollapseItem,
  Uploader,
} from "vant";

Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(NavBar);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(VanImage);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Empty);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Uploader);

Vue.config.productionTip = false;
/** 微信开放标签 <wx-open-subscribe> 等，避免 Vue 当作未知组件告警 */
Vue.config.ignoredElements = [/^wx-/];
Vue.prototype.$api = api;

console.log(
  `%c[BUILD] ${new Date().toISOString()} | API=${process.env.VUE_APP_BASE_API} | BASE_URL=${process.env.VUE_APP_BASE_URL}`,
  'color:#0af;font-weight:bold'
);

// 始终开启 VConsole，方便手机调试
import("vconsole").then(({ default: VConsole }) => {
  new VConsole();
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
